import { useEntryStore } from '../../store/entry/entryStore';
import StartScreen from '../../components/Screens/StartScreen/StartScreen';
import SelectionScreen from '../../components/Screens/SelectionScreen/SelectionScreen';

const PrePlayController = () => {
  const playClicked = useEntryStore((s) => s.playClicked);
  const entry = useEntryStore((s) => s.entry);

  if (!playClicked && !entry) return <StartScreen />;

  return <SelectionScreen />;
};
export default PrePlayController;
